import { connect } from 'react-redux';
import { Can } from './Can';

class Cannot extends Can {
  enabledValue() {
    return !super.enabledValue();
  }
}

const mapStateToProps = (state) => {
  const { permissionsMap } = state.entitlements;
  return {
    permissionsMap
  };
};

export default connect(mapStateToProps)(Cannot);
